<div class="primary-container">
  <span class="link-text">
    <!-- `text` is a name (data); the action texts are written in the code -->
    <span (click)="emitDefaultClick()" title="{{ defaultTitle | term }}">{{
      text
    }}</span>
    <div class="link-actions-container">
      <ng-container *ngFor="let action of actions">
        <clr-icon
          title="{{ action.text | term }}"
          class="link-action"
          [attr.shape]="action.shape"
          (click)="emitClick(action)"
        >
        </clr-icon>
      </ng-container>
    </div>
  </span>
</div>
